<template>
  <Header
    :bgIMG="bgIMG"
    :isCenter="true"
    :subTitle="'Poyanil Hospital'"
    :title="'Careers'"
  />
  <CareerDetail />
  <Stats />
</template>

<script lang="ts">
import { defineComponent } from "vue";

import Header from "@/components/CarouselHeader.vue";
import Stats from "@/components/Stats.vue";
import CareerDetail from "@/components/CareerDetail/Template3/CareerDetail.vue";

export default defineComponent({
  components: {
    Header,
    Stats,
    CareerDetail,
  },
  data() {
    return {
      bgIMG: require("@/assets/img/doctors-banner.png"),
    };
  },
});
</script>
